var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32097 2.81295C5.43509 -0.296775 10.4974 -0.263709 13.6305 2.86946C16.7651 6.00398 16.7968 11.0693 13.683 14.183C10.5692 17.2968 5.50394 17.2651 2.36943 14.1305C0.511909 12.2731 -0.255147 9.7389 0.0742314 7.33586C0.120385 6.99912 0.430769 6.76361 0.767483 6.80976C1.10421 6.85592 1.33975 7.16626 1.2936 7.503C1.01465 9.53812 1.66385 11.6844 3.23971 13.2603C5.90185 15.9224 10.1878 15.9376 12.8127 13.3127C15.4376 10.6878 15.4224 6.40189 12.7602 3.73975C10.0994 1.07896 5.81653 1.06237 3.19126 3.68324L3.80476 3.68632C4.14462 3.68803 4.41875 3.96493 4.41704 4.30479C4.41534 4.64466 4.13844 4.91878 3.79857 4.91708L1.70992 4.90658C1.37246 4.90488 1.09933 4.63174 1.09763 4.2943L1.08714 2.20563C1.08542 1.86578 1.35956 1.58888 1.69942 1.58716C2.03929 1.58546 2.31618 1.85959 2.31789 2.19946L2.32097 2.81295ZM7.99992 4.6025C8.33978 4.6025 8.6153 4.87802 8.6153 5.21789V8.24507L10.4863 10.1161C10.7266 10.3564 10.7266 10.7461 10.4863 10.9863C10.246 11.2267 9.85633 11.2267 9.61609 10.9863L7.38454 8.75485V5.21789C7.38454 4.87802 7.66006 4.6025 7.99992 4.6025Z",
    fill: "#4A6BB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakdownIcon);
export default __webpack_public_path__ + "static/media/breakdownIcon.1898f9e5c0fa4917e0f1d1d7cce9006d.svg";
export { ForwardRef as ReactComponent };